import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DisputeStorageService {
  private disputeFormState = new BehaviorSubject<any>({});
  disputeFormState$ = this.disputeFormState.asObservable();

  private progressValue = new BehaviorSubject<number>(0);
  private summaryValue = new BehaviorSubject<number>(0);
  private confirmationValue = new BehaviorSubject<number>(0);

  progressValue$ = this.progressValue.asObservable();
  summaryValue$ = this.summaryValue.asObservable();
  confirmationValue$ = this.confirmationValue.asObservable();

  private updatingStore = false; // Flag to prevent recursive updates

  updateDisputeFormState(updatedValues: Partial<any>): void {
    if (this.updatingStore) {
      return; // Prevent further updates while processing
    }

    this.updatingStore = true;

    try {
      const currentState = this.disputeFormState.getValue();
      const newState = { ...currentState, ...updatedValues };
      this.disputeFormState.next(newState);
      this.calculateProgress(newState);
    } finally {
      this.updatingStore = false;
    }
  }

  // Calculate progress, summary, and confirmation values
  private calculateProgress(formState: any): void {
    let progress = 0;

    if (formState.type) progress += 20;
    if (formState.priority) progress += 20;
    if (formState.reason) progress += 20;
    if (formState.amount) progress += 20;
    if (formState.note) progress += 20;
    if (formState.file) progress += 10;

    this.progressValue.next(progress);

    // Reset summary and confirmation when progress is recalculated
    if (progress < 100) {
      this.summaryValue.next(0);
      this.confirmationValue.next(0);
    }
  }

  // Method to manually update the summary value
  updateSummaryValue(value: number): void {
    this.summaryValue.next(value);
  }

  // Method to manually update the confirmation value
  updateConfirmationValue(value: number): void {
    this.confirmationValue.next(value);
  }

  // Getters for observables
  get infovalue(): Observable<number> {
    return this.progressValue$;
  }

  get summaryvalue(): Observable<number> {
    return this.summaryValue$;
  }

  get confirmationvalue(): Observable<number> {
    return this.confirmationValue$;
  }

  // Method to flush/reset the store
  resetStore(): void {
    this.disputeFormState.next({});
    this.progressValue.next(0);
    this.summaryValue.next(0);
    this.confirmationValue.next(0);
  }
}
